import _asyncToGenerator from "@babel/runtime/helpers/asyncToGenerator";
import _regeneratorRuntime from "@babel/runtime/regenerator";
import "core-js/modules/es.number.constructor.js";
import "core-js/modules/es.array.concat.js";
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//

import axios from 'axios';
import { newPageRebookRuleListUrl } from '@/apis/index';
export default {
  name: 'rebook-project-detail',
  props: {
    performanceId: {
      type: Number
    },
    useRebookRuleVO: {
      type: Boolean
    },
    rebookRuleVO: {
      type: Object
    }
  },
  data: function data() {
    return {
      projectRebookData: {}
    };
  },
  mounted: function mounted() {
    if (this.performanceId && !this.useRebookRuleVO) {
      this.getProjectRebookRule();
    } else {
      this.projectRebookData = this.rebookRuleVO || {};
    }
  },
  methods: {
    getProjectRebookRule: function getProjectRebookRule() {
      var _this = this;
      return _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime.mark(function _callee() {
        var url, _yield$axios$get, _yield$axios$get$data, data, customInfo;
        return _regeneratorRuntime.wrap(function _callee$(_context) {
          while (1) switch (_context.prev = _context.next) {
            case 0:
              _context.prev = 0;
              url = newPageRebookRuleListUrl;
              _context.next = 4;
              return axios.get("".concat(url, "?projectId=").concat(_this.performanceId));
            case 4:
              _yield$axios$get = _context.sent;
              _yield$axios$get$data = _yield$axios$get.data;
              data = _yield$axios$get$data === void 0 ? {} : _yield$axios$get$data;
              if (!data) data = {};
              _this.projectRebookData = data;
              _context.next = 15;
              break;
            case 11:
              _context.prev = 11;
              _context.t0 = _context["catch"](0);
              // 项目信息
              customInfo = {
                projectId: _this.performanceId
              };
              _this.$owlReportError('改签政策模块-获取项目详情页改签政策列表失败', _context.t0, customInfo);
            case 15:
            case "end":
              return _context.stop();
          }
        }, _callee, null, [[0, 11]]);
      }))();
    }
  }
};